var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRectangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.665 36.4572C34.5413 35.7177 36.6668 33.1071 36.6668 30V10C36.6668 6.31814 33.6821 3.33337 30.0002 3.33337H10.0002C6.31826 3.33337 3.3335 6.31814 3.3335 10V30C3.3335 33.1071 5.45903 35.7177 8.33534 36.4572M31.665 36.4572C31.1328 36.594 30.575 36.6667 30.0002 36.6667H10.0002C9.42533 36.6667 8.86748 36.594 8.33534 36.4572M31.665 36.4572C31.5532 30.1105 26.3735 25 20.0002 25C13.6268 25 8.44713 30.1105 8.33534 36.4572M25.0002 15C25.0002 12.2386 22.7616 10 20.0002 10C17.2387 10 15.0002 12.2386 15.0002 15C15.0002 17.7615 17.2387 20 20.0002 20C22.7616 20 25.0002 17.7615 25.0002 15Z",
    stroke: "#3545EE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRectangle);
export default __webpack_public_path__ + "static/media/user-rectangle.ee7b640865bdcac3e05f13d679d4c8fd.svg";
export { ForwardRef as ReactComponent };